/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/assets/js/modules/ua.js
var getBrowser = function getBrowser() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var ua = '';
  if (userAgent.indexOf('opera') !== -1) {
    ua = 'opera';
  } else if (userAgent.indexOf('edge') !== -1) {
    ua = 'edge';
  } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
    ua = 'ie';
  } else if (userAgent.indexOf('chrome') !== -1) {
    ua = 'chrome';
  } else if (userAgent.indexOf('safari') !== -1) {
    ua = 'safari';
  } else if (userAgent.indexOf('firefox') !== -1) {
    ua = 'firefox';
  } else if (userAgent.indexOf('gecko') !== -1) {
    ua = 'gecko';
  }
  return ua;
};
var getOS = function getOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var ua = '';
  if (userAgent.indexOf('iphone') !== -1) {
    ua = 'iphone';
  } else if (userAgent.indexOf('ipad') !== -1) {
    ua = 'ipad';
  } else if (userAgent.indexOf('android') !== -1) {
    ua = 'android';
  } else if (userAgent.indexOf('windows') !== -1) {
    ua = 'win';
  } else if (userAgent.indexOf('macintosh') !== -1) {
    ua = 'mac';
  }
  return ua;
};
var forDesktopOS = function forDesktopOS() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf('windows') !== -1 || userAgent.indexOf('macintosh') !== -1;
};
var setUserAgent = function setUserAgent() {
  var body = document.querySelector('body');
  body.classList.add("is-".concat(getBrowser()));
  body.classList.add("is-".concat(getOS()));
  body.classList.add("is-".concat(forDesktopOS() ? 'for-pc' : 'for-sp'));
};

;// CONCATENATED MODULE: ./src/assets/js/modules/in-view.js
// modules/in-view.js を丸っと置換
var InViewInit = function InViewInit() {
  var els = document.querySelectorAll('.in-view');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      return el.classList.add('is-in');
    }); // フォールバック
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (_ref) {
      var isIntersecting = _ref.isIntersecting,
        target = _ref.target;
      if (isIntersecting) {
        target.classList.add('is-in');
        // 一回きりなら次で監視解除
        io.unobserve(target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    // 少し手前で発火したければ調整
    threshold: 0.1
  });
  els.forEach(function (el) {
    return io.observe(el);
  });
};
;// CONCATENATED MODULE: ./src/assets/js/app.js


var loadCommonInit = function loadCommonInit() {
  setUserAgent();
  InViewInit();
};
window.addEventListener('DOMContentLoaded', function () {
  loadCommonInit();
});
/******/ })()
;
//# sourceMappingURL=pqDrinkPlusApp.js.map